var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66732 11.3333C1.30065 11.3333 0.986762 11.2027 0.725651 10.9416C0.46454 10.6805 0.333984 10.3666 0.333984 9.99996V1.99996C0.333984 1.63329 0.46454 1.3194 0.725651 1.05829C0.986762 0.797182 1.30065 0.666626 1.66732 0.666626H12.334C12.7007 0.666626 13.0145 0.797182 13.2757 1.05829C13.5368 1.3194 13.6673 1.63329 13.6673 1.99996V9.99996C13.6673 10.3666 13.5368 10.6805 13.2757 10.9416C13.0145 11.2027 12.7007 11.3333 12.334 11.3333H1.66732ZM7.00065 6.66663L1.66732 3.33329V9.99996H12.334V3.33329L7.00065 6.66663ZM7.00065 5.33329L12.334 1.99996H1.66732L7.00065 5.33329ZM1.66732 3.33329V1.99996V9.99996V3.33329Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailicon);
export default __webpack_public_path__ + "static/media/emailicon.1bf3868ef4136ddc9be420b6a99fad6e.svg";
export { ForwardRef as ReactComponent };